import React from 'react';
import './slides.css';

function Slides() {
  return (
    <div>
      <slider>
        <slide />
        <slide />
        <slide />
        <slide />
        <slide />
        <slide />
        <slide />
        <slide />
      </slider>
    </div>
  );
}

export default Slides;
